/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */

const ArrowDown = ({ size = "md" }) => {
  const sizeMap = {
    sm: {
      width: 10,
      height: 8,
    },
    md: {
      width: 18,
      height: 10,
    },
    lg: {
      width: 20,
      height: 20,
    },
  };

  return (
    <svg
      width={sizeMap[size].width}
      height={sizeMap[size].height}
      viewBox="0 0 18 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      test-id="cGaYhgK6"
    >
      <path
        d="M1 0.98999L9 8.98999L17 0.98999"
        stroke="#9A9A9A"
        test-id="1q7CCovG"
      />
    </svg>
  );
};

export default ArrowDown;
